module.exports = __webpack_public_path__ + "img/3.ca9dd66c.jpg";